var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcAi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 124,
    height: 124,
    viewBox: "0 0 124 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3124_25393)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 61,
    y: 72,
    width: 61,
    height: 15,
    fill: "url(#paint0_radial_3124_25393)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61,
    y: 89,
    width: 61,
    height: 15,
    fill: "url(#paint1_radial_3124_25393)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61,
    y: 106,
    width: 61,
    height: 15,
    fill: "url(#paint2_radial_3124_25393)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 74,
    width: 10,
    height: 4,
    fill: "url(#paint3_radial_3124_25393)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 91,
    width: 10,
    height: 4,
    fill: "url(#paint4_radial_3124_25393)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 107,
    width: 10,
    height: 4,
    fill: "url(#paint5_radial_3124_25393)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50 93C73.7482 93 93 73.7482 93 50C93 26.2518 73.7482 7 50 7C26.2518 7 7 26.2518 7 50C7 73.7482 26.2518 93 50 93ZM45.904 54.052L47.848 61H51.7L44.14 35.872H39.28L31.756 61H35.5L37.444 54.052H45.904ZM41.872 39.328L42.664 43L45.004 50.92H38.38L40.612 43L41.404 39.328H41.872ZM54.2453 57.94V61H64.1813V57.94H61.1213V38.932H64.1813V35.872H54.2453V38.932H57.3053V57.94H54.2453Z",
    fill: "url(#paint6_radial_3124_25393)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.4813 88.8869L47.482 85.9989L47.4805 91.7724L52.4813 88.8869ZM16.8633 69.1949C6.23186 50.7806 12.5411 27.2344 30.9553 16.6029L30.4553 15.7369C11.5628 26.6445 5.08969 50.8024 15.9973 69.6949L16.8633 69.1949ZM30.9553 16.6029C49.3696 5.97145 72.9158 12.2806 83.5473 30.6949L84.4133 30.1949C73.5057 11.3024 49.3479 4.82929 30.4553 15.7369L30.9553 16.6029ZM48.0095 88.3866C35.5025 87.6604 23.5945 80.8536 16.8633 69.1949L15.9973 69.6949C22.9038 81.6573 35.1228 88.6401 47.9516 89.385L48.0095 88.3866ZM83.5473 30.6949C92.8251 46.7645 89.2017 66.7435 75.8898 78.6358L76.556 79.3815C90.214 67.1801 93.9327 46.6829 84.4133 30.1949L83.5473 30.6949Z",
    fill: "url(#paint7_linear_3124_25393)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_3124_25393",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(103.041 76.5732) rotate(166.071) scale(43.3143 18.3788)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C0FF",
    stopOpacity: 0.85
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C0FF",
    stopOpacity: 0.55
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_3124_25393",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(103.041 93.5732) rotate(166.071) scale(43.3143 18.3788)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C0FF",
    stopOpacity: 0.85
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C0FF",
    stopOpacity: 0.55
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_3124_25393",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(103.041 110.573) rotate(166.071) scale(43.3143 18.3788)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C0FF",
    stopOpacity: 0.85
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C0FF",
    stopOpacity: 0.55
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_3124_25393",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(70.8919 75.2195) rotate(158.029) scale(7.43164 4.68278)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C0FF",
    stopOpacity: 0.85
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C0FF",
    stopOpacity: 0.55
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_3124_25393",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(70.8919 92.2195) rotate(158.029) scale(7.43164 4.68278)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C0FF",
    stopOpacity: 0.85
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C0FF",
    stopOpacity: 0.55
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_3124_25393",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(70.8919 108.22) rotate(158.029) scale(7.43164 4.68278)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C0FF",
    stopOpacity: 0.85
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C0FF",
    stopOpacity: 0.55
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_3124_25393",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(66.2703 33.2195) rotate(134.754) scale(84.1824 76.4371)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C0FF",
    stopOpacity: 0.85
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C0FF",
    stopOpacity: 0.55
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_3124_25393",
    x1: 13.5056,
    y1: 39.3792,
    x2: 81.9768,
    y2: 67.9747,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3124_25393"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 124,
    height: 124,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAi);
export default __webpack_public_path__ + "static/media/ic_AI.d34216995bbd8043b0058ad9b25eea46.svg";
export { ForwardRef as ReactComponent };